import { colors } from "./colors";
import { fonts } from "./fonts";
import { components } from "./components";
import { extendTheme } from "@chakra-ui/react";

const appTheme = extendTheme({
  colors,
  ...fonts,
  // components,
});

export type AppThemeType = typeof appTheme;

export default appTheme;
